import { MaterialReactTable } from 'material-react-table'
import { useEffect, useState } from 'react'
import { useAdTeamStore } from 'src/stores/AdTeamStore'
import { LoadTeam } from './useLoadTeam'

const TableHeaderSx = {
  backgroundColor: '#30515B',
  color: 'white',
  fontSize: '14px',
  textAlign: 'center',
  '& .Mui-TableHeadCell-Content': {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    height: '100%',
  },
  '&:first-of-type': {
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
  },
  '&:last-of-type': {
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
  },
}

const TableCellSx = {
  textAlign: 'center',
  verticalAlign: 'middle',
  fontSize: '16px',
}

const LeftTable = () => {
  const setField = useAdTeamStore((state)=>state.setField)
  const selectedTeam = useAdTeamStore((state)=>state.selectedTeam)
  const tableData = useAdTeamStore((state)=>state.tableData)
  const [data,setData] = useState<any[]>([])
  const [selectedRowIndex, setSelectedRowIndex] = useState<number>(0);
    useEffect(()=>{
      LoadTeam()
    },[])

    useEffect(()=>{
      setData(tableData)
    },[tableData])

    useEffect(()=>{
      if(!selectedTeam){
        setField('selectedTeam',data?.[0] ?? null)
      }
      else{
        setField('selectedTeam',data[selectedRowIndex])
      }
    //eslint-disable-next-line
    },[data])

  return (
    <div style={{width:'100%'}}>
        <MaterialReactTable
            data={data}
            muiTableContainerProps={{
            sx: { flex: 1, 
                  overflowY: 'auto',
                  height:'calc(100vh - 260px)'
            }
            }}
            columns={[
            { accessorKey:'team_name', header: '팀명'},
            { accessorKey:'manager_name',header: '팀장',
              Cell: ({ cell }) => cell.getValue() || '-'  // falsy 값일 경우 '-'
            },
            { accessorKey:'team_count',header:'인원'},
            ]}
            // 툴바, sort 버튼 등
            enableSorting={false} // ✅ 전체 정렬 기능 제거
            enableTopToolbar={false}
            enableBottomToolbar={false}
            enableColumnActions={false}
            muiTablePaperProps={{
            elevation: 0, // ✅ 그림자 제거
            }}
            // 로우 헤더 스타일
            muiTableHeadCellProps={{
            sx: TableHeaderSx,
            }}
            // 로우 스타일
            muiTableBodyRowProps={({ row }) => ({
              onClick: () => {
                const rowData = row.original;
                setSelectedRowIndex(row.index);
                setField('selectedTeam',rowData)
              },
              sx: {
                cursor: 'pointer',
                height: '49px',
                '& > td:first-of-type': {
                  borderTopLeftRadius: '5px',
                  borderBottomLeftRadius: '5px',
                  borderTop: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                },
                '& > td:last-of-type': {
                  borderTopRightRadius: '5px',
                  borderBottomRightRadius: '5px',
                  borderRight: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                },
                '& > td': {
                  boxShadow: '1px 2px 2px 0 rgba(0, 0, 0, 0.1)',
                  padding: '4px',
                  backgroundColor: row.index === selectedRowIndex ? '#E0EBEB' : '#FFF',
                  borderTop: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                  borderBottom: row.index === selectedRowIndex ? '1px solid #229596' : 'none',
                },
              },
            })}
            // 셀 스타일
            muiTableBodyCellProps={{
            sx: TableCellSx,
            }}
            // 테이블 스타일
            muiTableProps={{
            sx: {
                borderCollapse: 'separate',
                borderSpacing: '0 5px', // ✅ row 간격 5px
                '& .MuiTableSortLabel-icon': {
                color: '#aaa',
                fontSize: '1.5rem',
                },
                '& .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon': {
                color: 'rgb(255, 255, 255) !important',
                },
            }}}
            // 페이지 네이션 옵션
            manualPagination 
            // 솔팅 옵션
            manualSorting
            enableSortingRemoval={false}
            />
    </div>
  )
}

export default LeftTable